import React from "react"
import {
  footerSocialLinks,
  footerSocialItem,
} from "./social-medias.module.scss"
import Icon from "../Icon/icon"
import PropTypes from "prop-types"
import { useBuildData } from "../../hooks/use-build-data"

const SocialMedias = ({ iconSize }) => {
  const buildInfos = useBuildData().site_settings
  const tabIcon = {
    facebook: buildInfos.facebook_url,
    instagram: buildInfos.instagram_url,
    twitter: buildInfos.twitter_url,
    youtube: buildInfos.youtube_url,
    linkedin2: buildInfos.linkedin_url,
  }
  return (
    <ul className={footerSocialLinks}>
      {Object.keys(tabIcon).map((socialIconName) => (
        <React.Fragment key={socialIconName}>
          {tabIcon[socialIconName] && (
            <li className={footerSocialItem}>
              <a
                aria-label={`Suivez nous sur ${socialIconName}`}
                target="_blank"
                rel="noopener noreferrer"
                href={tabIcon[socialIconName]}
              >
                <Icon size={iconSize} icon={socialIconName} />
              </a>
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  )
}

//-----------------------Prop-Types---------------------------//

SocialMedias.propTypes = {
  iconSize: PropTypes.number,
}
SocialMedias.defaultProps = {
  iconSize: 20,
}
//-----------------------Prop-Types---------------------------//

export default SocialMedias
